// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography } from '@material-ui/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding:   theme.spacing(1),
    textAlign: 'center',
    color:     theme.palette.text.secondary,
  },
}));

const GridList = ({ value }) => {
  const classes = useStyles();
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: value.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  function FormRow() {
    return (
      <>
        <Grid item xs={12}>
          <Paper className={classes.paper} elevation={2}>
            <Typography variant="subtitle1">
              <div><b>{value.title}</b></div>
            </Typography>
          </Paper>
        </Grid>
      </>
    );
  }
  return (
    <div style={style}>
      <div ref={setNodeRef} {...attributes} {...listeners}>
        <div className={classes.root}>
          <Grid container item sm={12} style={{ marginBottom: 10 }}>
            <FormRow />
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default GridList;

GridList.propTypes = {
  value: PropTypes.objectOf(PropTypes.any).isRequired,
};
